import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';
import React from 'react';

interface ISearchBoxProps {
  placeholder?: string;
  value?: string;
  onChange(text: string): void;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = props => (
  <div className={'search-box'}>
    <div className="position-relative">
      <div className="d-flex align-items-center">
        <Form.Control
          type="search"
          placeholder={props.placeholder}
          className={'search-input search'}
          size="sm"
          value={props.value}
          onChange={e => props.onChange(e.target.value)}
        />
        <FontAwesomeIcon
          icon={faSearch}
          className="search-box-icon"
          onClick={e => console.log(e.target)}
        />
        <button
          type="button"
          className="btn-close ms-2"
          aria-label="Clear"
          onClick={() => props.onChange('')}
        ></button>
      </div>
    </div>
  </div>
);

export default SearchBox;
